import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/logos/horizontal-dark.svg';
import _imports_1 from '../assets/images/logos/horizontal.svg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3558af03"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "logo"
};
var _hoisted_2 = ["alt"];
var _hoisted_3 = ["alt"];

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" Beta ");

var _hoisted_5 = {
  key: 3,
  class: "responsive-menu"
};
import { h, ref, computed } from "vue";
import { RouterLink, useRoute, useRouter } from "vue-router";
import { useWindowSize } from "@vueuse/core";
import { AlertCircleOutline, MenuSharp, Notifications, Sunny, Moon } from "@vicons/ionicons5";
import { NIcon, useThemeVars } from "naive-ui";
import { useUXStore } from "@/store/ux";
import { useUserStore } from "@/store/user";
import { useIsMobile } from "@/utils/reactive";
import { navRouterLink, renderIcon } from "@/utils/components";
import ExtensionButton from "@/components/ExtensionButton.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var uxStore = useUXStore();
    var userStore = useUserStore();
    var themeVars = useThemeVars();
    var windowSize = useWindowSize();
    var isMobile = useIsMobile();
    var appName = process.env.VUE_APP_NAME;
    var threshold = 935;

    var addOptions = function addOptions(menu, options) {
      var _iterator = _createForOfIteratorHelper(options),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var option = _step.value;
          menu.push(option);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    var unvalidatedIcon = h(NIcon, {
      size: 24,
      color: themeVars.value.warningColor
    }, {
      default: function _default() {
        return h(AlertCircleOutline);
      }
    });
    var active = ref(route.name);
    var extensionItem = {
      label: function label() {
        return h(ExtensionButton);
      },
      key: "extension"
    };
    var itemsLeft = computed(function () {
      var options = [];
      addOptions(options, [navRouterLink("MessageLookup", "Search")]);

      if (userStore.authenticated) {
        addOptions(options, [navRouterLink("NewMessage", "New message"), navRouterLink("Groups", "Groups")]);
      }

      return options;
    });
    var itemsRight = computed(function () {
      var _userStore$user;

      var accountItemParams = userStore.authenticated && !((_userStore$user = userStore.user) !== null && _userStore$user !== void 0 && _userStore$user.emailConfirmed) ? {
        icon: unvalidatedIcon,
        style: "color: ".concat(themeVars.value.warningColor, ";")
      } : {};
      var options = [];
      addOptions(options, [{
        label: collapsed.value ? uxStore.theme === "dark" ? "Light mode" : "Dark mode" : undefined,
        key: "theme",
        icon: renderIcon(uxStore.theme === "dark" ? Sunny : Moon)
      }]);

      if (!userStore.authenticated) {
        addOptions(options, [navRouterLink("Signin", "Sign in"), navRouterLink("Signup", "Sign up")]);
      }

      if (userStore.authenticated) {
        var _userStore$user2;

        addOptions(options, [_objectSpread(_objectSpread({}, navRouterLink("Notifications", collapsed.value ? "Notifications" : undefined)), {}, {
          icon: !collapsed.value ? renderIcon(Notifications, userStore.hasUnreadNotification ? {
            color: themeVars.value.errorColor
          } : {}) : undefined
        }), {
          label: (_userStore$user2 = userStore.user) === null || _userStore$user2 === void 0 ? void 0 : _userStore$user2.userName,
          key: "user",
          children: [navRouterLink("Account", "Account", accountItemParams), navRouterLink("Messages", "Messages"), {
            label: "Logout",
            key: "logout"
          }]
        }]);
      }

      return options;
    });
    var responsiveItems = computed(function () {
      var options = [].concat(_toConsumableArray(itemsLeft.value), _toConsumableArray(itemsRight.value));
      var theme = options.find(function (o) {
        return o.key === "theme";
      });
      return [theme].concat(_toConsumableArray(options.filter(function (o) {
        return o.key !== "theme";
      })));
    });
    var collapsed = computed(function () {
      return windowSize.width.value < threshold;
    });

    var logout = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userStore.appLogout();
                _context.next = 3;
                return router.push({
                  name: "Home"
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function logout() {
        return _ref.apply(this, arguments);
      };
    }();

    var onUpdate = function onUpdate(key) {
      switch (key) {
        case "theme":
          uxStore.setMode(uxStore.theme === "dark" ? "light" : "dark");
          break;

        case "logout":
          logout();
          break;
      }
    };

    return function (_ctx, _cache) {
      var _component_n_tag = _resolveComponent("n-tag");

      var _component_n_menu_item = _resolveComponent("n-menu-item");

      var _component_n_menu = _resolveComponent("n-menu");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_dropdown = _resolveComponent("n-dropdown");

      return _openBlock(), _createElementBlock("nav", {
        class: _normalizeClass(["main-navigation d-flex flex-row justify-content-between align-items-center", {
          'collapsed': _unref(collapsed)
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(RouterLink), {
        to: {
          name: 'Home'
        },
        class: "d-block text-decoration-none h-100 d-flex justify-content-center align-items-center"
      }, {
        default: _withCtx(function () {
          return [_unref(uxStore).theme === 'dark' ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            alt: _unref(appName),
            src: _imports_0
          }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("img", {
            key: 1,
            alt: _unref(appName),
            src: _imports_1
          }, null, 8, _hoisted_3)), _createVNode(_component_n_tag, {
            type: "info",
            size: "small",
            class: "ms-2 rounded"
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1
          })];
        }),
        _: 1
      })]), !_unref(collapsed) ? (_openBlock(), _createBlock(_component_n_menu, {
        key: 0,
        value: active.value,
        "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
          return active.value = $event;
        }),
        mode: "horizontal",
        options: _unref(itemsLeft),
        class: _normalizeClass({
          'flex-fill': _unref(isMobile)
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_menu_item)];
        }),
        _: 1
      }, 8, ["value", "options", "class"])) : _createCommentVNode("", true), !_unref(isMobile) ? (_openBlock(), _createBlock(_component_n_menu, {
        key: 1,
        value: active.value,
        "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
          return active.value = $event;
        }),
        mode: "horizontal",
        options: [extensionItem],
        class: "flex-fill"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_menu_item)];
        }),
        _: 1
      }, 8, ["value", "options"])) : _createCommentVNode("", true), !_unref(collapsed) ? (_openBlock(), _createBlock(_component_n_menu, {
        key: 2,
        value: active.value,
        "onUpdate:value": [_cache[2] || (_cache[2] = function ($event) {
          return active.value = $event;
        }), onUpdate],
        mode: "horizontal",
        options: _unref(itemsRight)
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_menu_item)];
        }),
        _: 1
      }, 8, ["value", "options"])) : _createCommentVNode("", true), _unref(collapsed) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_n_dropdown, {
        trigger: "click",
        size: "huge",
        placement: "bottom-end",
        keyboard: false,
        options: _unref(responsiveItems),
        onSelect: _cache[3] || (_cache[3] = function (key) {
          return onUpdate(key);
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            secondary: "",
            round: false,
            size: "large",
            class: "responsive-trigger"
          }, {
            icon: _withCtx(function () {
              return [_createVNode(_unref(NIcon), null, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(MenuSharp))];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["options"])])) : _createCommentVNode("", true)], 2);
    };
  }
});